<template>
  <div class="SegundaViaCasamento">
    <div class="SegundaViaCasamento_body">
      <div class="SegundaViaCasamento_header">
        Dados do registrador
      </div>
      <div class="SegundaViaCasamento_body_content p-2">
        <div class="row px-2">
          <div class="col-5">
            <div class="form-group">
              <label class="label">
                Nome do digitador
              </label>
              <select ref="nome_digitador"
                      v-model="casamento.registro.digitador"
                      v-validate="'required'"
                      class="form-control form-control-sm"
                      :class="{'is-invalid' : errors.has('digitador')}"
                      required
                      name="digitador"
                      @change="changed()">
                <option :value="null">
                  Selecione o digitador:
                </option>
                <option v-for="(digitador, index) of digitadores"
                        :key="index"
                        :value="digitador.nome">
                  {{ digitador.nome }}
                </option>
              </select>
              <small v-if="errors.has('digitador')"
                     class="invalid-feedback">
                {{ errors.first('digitador') }}
              </small>
            </div>
          </div>
          <div class="col-4">
            <div class="form-group">
              <label class="label">
                Escrevente
              </label>
              <select id="selectEscrevente"
                      v-model="casamento.registro.escrevente"
                      v-validate="'required'"
                      class="form-control form-control-sm"
                      :class="{'is-invalid' : errors.has('escrevente')}"
                      required
                      name="escrevente"
                      @change="changeEscrevente()">
                <option :value="null">
                  Selecione o escrevente:
                </option>
                <option v-for="(escrevente, index) of escreventes"
                        :key="index"
                        :value="escrevente.nome">
                  {{ escrevente.nome }}
                </option>
              </select>
              <small v-if="errors.has('escrevente')"
                     class="invalid-feedback">
                {{ errors.first('escrevente') }}
              </small>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="SegundaViaCasamento_body">
      <div class="SegundaViaCasamento_header">
        Dados do registro
      </div>
      <div class="SegundaViaCasamento_body_content p-2">
        <div>
          <div v-if="!casamento.registro.registro_id"
               class="col-12 d-inline-flex m-0 p-0">
            <div class="col-sm-12 px-2">
              <div class="form-group">
                <label for=""
                       class="label d-block">1ª via ou Legado</label>
                <span class="custom-control custom-radio custom-control-inline">
                  <input
                    id="primeiraViaRegistro"
                    v-model="casamento.registro.origem"
                    class="custom-control-input"
                    checked
                    name="primeiraViaRegistro"
                    type="radio"
                    value="novo"
                    @change="changeOrigin('novo')"
                    @keyup.enter="casamento.registro.origem = 'novo'">
                  <label
                    class="custom-control-label"
                    for="primeiraViaRegistro">1ª via</label>
                </span>

                <span class="custom-control custom-radio custom-control-inline">
                  <input
                    id="legadoRegistro"
                    v-model="casamento.registro.origem"
                    class="custom-control-input"
                    name="legadoRegistro"
                    value="legado"
                    type="radio"
                    @change="changeOrigin('legado')"
                    @keyup.enter="propCasamento.registro.origem = 'legado'">
                  <label
                    class="custom-control-label"
                    for="legadoRegistro">Legado</label>
                </span>
              </div>
            </div>
          </div>
          <div v-if="casamento.registro.origem === 'legado' || casamento.registro.registro_id"
               class="row px-2 mb-4">
            <div class="col-2">
              <label
                class="label"
                for="falecido_digitador_nome">Livro</label>
              <input v-model="casamento.registro.livro.num_livro"
                     v-validate="'required'"
                     type="number"
                     name="registro_livro"
                     :class="{'is-invalid' : errors.has('registro_livro')}"
                     class="form-control form-control-sm"
                     @change="changed()">
            </div>

            <div class="col-2">
              <label
                class="label"
                for="falecido_digitador_nome">Folha</label>
              <input v-model="casamento.registro.folha"
                     v-validate="'required'"
                     type="number"
                     name="registro_folha"
                     :class="{'is-invalid' : errors.has('registro_folha')}"
                     class="form-control form-control-sm"
                     @change="changed()">
            </div>

            <div class="col-2">
              <label
                class="label"
                for="falecido_digitador_nome">Termo</label>
              <input v-model="casamento.registro.termo"
                     v-validate="'required'"
                     type="number"
                     name="registro_termo"
                     :class="{'is-invalid' : errors.has('registro_termo')}"
                     class="form-control form-control-sm"
                     @change="changed()">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="SegundaViaCasamento_body">
      <div class="SegundaViaCasamento_header">
        Dados do casamento
      </div>
      <div class="SegundaViaCasamento_body_content p-2">
        <div class="row">
          <div class="col-5">
            <div class="form-group">
              <label for="casamento_tipo"
                     class="label">
                Tipo de casamento <span class="text-danger">*</span>
              </label>
              <select id="casamento_tipo"
                      v-model="casamento.tipo_casamento"
                      v-validate="'required'"
                      class="form-control form-control-sm"
                      :class="{'is-invalid':errors.has('tipo_casamento')}"
                      required
                      name="tipo_casamento"
                      @change="[verifyDataCasamento(), verifyCasamentoCartorio()]">
                <option :value="null">
                  Selecione o tipo
                </option>
                <option v-for="(tipo, index) in selects.tipo"
                        :key="`tipo_casamento_${index}`">
                  {{ tipo }}
                </option>
              </select>
              <small v-if="errors.has('tipo_casamento')"
                     class="text-danger">
                Selecione o tipo de casamento.
              </small>
            </div>
          </div>
          <div class="col-2">
            <div class="form-group">
              <label for="dados_casamento_data_casamento"
                     class="label">
                Data do casamento
                <span v-if="[CASAMENTO_RELIGIOSO, UNIAO_ESTAVEL, CASAMENTO_CIVIL_OUTRO_CARTORIO].indexOf(casamento.tipo_casamento) == -1"
                      class="text-danger">*</span>
              </label>
              <input id="dados_casamento_data_entrada"
                     ref="data_casamento"
                     v-model="casamento.data_casamento"
                     v-validate="[ {required: [CASAMENTO_RELIGIOSO, UNIAO_ESTAVEL, CASAMENTO_CIVIL_OUTRO_CARTORIO].indexOf(casamento.tipo_casamento) == -1}, `date_format:yyyy-MM-dd|date_between:${ '1500-01-01' },${ '2500-01-01' }, (include)`]"
                     type="date"
                     class="form-control form-control-sm"
                     :class="{'is-invalid':errors.has('data_casamento')}"
                     :required="[CASAMENTO_RELIGIOSO, UNIAO_ESTAVEL, CASAMENTO_CIVIL_OUTRO_CARTORIO].indexOf(casamento.tipo_casamento) == -1"
                     name="data_casamento">
              <small v-if="errors.has('data_casamento')"
                     class="text-danger">
                {{ errors.first('data_casamento') }}
              </small>
            </div>
          </div>
          <div class="col-2">
            <div class="form-group">
              <label for="dados_casamento_data_registro"
                     class="label">
                Data do registro
                <span class="text-danger">*</span>
              </label>
              <input id="dados_casamento_data_registro"
                     ref="data_registro"
                     v-model="casamento.registro.data_registro"
                     v-validate="`date_format:yyyy-MM-dd|date_between:${ '1500-01-01' },${ '2500-01-01' }, (include)`"
                     type="date"
                     class="form-control form-control-sm"
                     :class="{'is-invalid':errors.has('data_registro')}"
                     required
                     name="data_registro"
                     @change="changed()">
              <small v-if="errors.has('data_registro')"
                     class="text-danger">
                {{ errors.first('data_registro') }}
              </small>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-5">
            <div class="form-group">
              <label for="casamento_regime"
                     class="label">
                Regime de bens
              </label>

              <select id="casamento_regime"
                      v-model="casamento.regime_bens"
                      class="form-control form-control-sm"
                      @change="getComplemento()">
                <option :value="null">
                  Selecione o tipo
                </option>
                <option v-for="(regime, index) in regimeDeBens"
                        :key="`regime_casamento_${index}`"
                        :value="regime.value">
                  {{ regime.text }}
                </option>
              </select>
            </div>
          </div>

          <div class="col-12">
            <div class="form-group">
              <label for="regime_bens_complemento"
                     class="label">
                Complemento
              </label>
              <TextAutoComplete :prop-list="complementos"
                                :prop-habilitacao="casamento"
                                @change="changeComplemento" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-for="(pessoa, index) in casamento.registro.pessoas"
         :key="index"
         class="SegundaViaCasamento_body pt-2">
      <div class="SegundaViaCasamento_header">
        Cônjuge {{ index + 1 }}
      </div>
      <div class="SegundaViaCasamento_body_content p-2">
        <ConjugeSV :prop-pessoa="pessoa"
                   :prop-casamento="casamento"
                   :prop-index="index"
                   @removeGenitor="removeGenitor" />
      </div>
    </div>
    <hr>
    <div class="row justify-content-end">
      <div class="col-1">
        <button v-if="casamento.registro && casamento.registro.existe_crc"
                id="btn-submit-registro-alteracao"
                v-b-modal.modalMotivoAlteracao
                class="btn btn-sm btn-secondary"
                type="button">
          Salvar
        </button>
        <button v-else
                id="btn-submit-registro"
                class="btn btn-sm btn-secondary"
                @click="verifyInputs()">
          Salvar
        </button>
      </div>
    </div>
    <MotivoAlteracao tipo="C"
                     :tarefa-alteracao-carga="tarefaAlteracaoCarga"
                     @gravarAtualizacao="atualizarRegistro($event)" />
  </div>
</template>

<script>
/* components */
  import ConjugeSV from "@/components/SofiaRei/Casamento/SegundaVia/ConjugeSV"
  import TextAutoComplete from "@/components/SofiaRei/TextAutoComplete.vue"
  import MotivoAlteracao from '@/components/SofiaRei/Resumo/MotivoAlteracao.vue'

  /* constants */
  import SEXOS from "@/constants/sexos"
  import brazilianStates from "@/constants/brazilianStates"
  import { ESTADOS_CIVIL_HABILITACAO } from "@/constants/estadosCivil"
  import { tipos, EDITAL_OUTRA_SERVENTIA, A_VISTA_HABILITACAO, UNIAO_ESTAVEL, CASAMENTO_RELIGIOSO_EFEITO_CIVIL, CASAMENTO_RELIGIOSO, CASAMENTO_CIVIL_OUTRO_CARTORIO } from "@/constants/casamento/tipos"

  /* services */
  import RegimeBensService from "@/services/Registros/RegimeBensService"
  import CasamentoService from "@/services/Registros/Casamento"
  import UsuarioService from "@/services/Auth/UsuarioService"

  /* outros */
  import moment from "moment"

  /* libraries */
  import { mapGetters } from "vuex"

  export default {
    name: 'SegundaViaCasamento',
    components: {
      ConjugeSV,
      TextAutoComplete,
      MotivoAlteracao
    },
    props: {
      propCasamento: { type: Object, default: () => {}}
    },
    provide () {
      return {
        $validator: this.$validator,
      }
    },
    data () {
      return {
        showNatDeclarada: false,
        show_naturalidade: true,
        constants: {
          brazilianCities: []
        },
        selects: {
          tipo: [
            ...tipos
          ],
          regime: [
            { text: "Comunhão parcial de bens" },
            { text: "Comunhão universal de bens" },
            { text: "Participação final aquestos" },
            { text: "Separação de Bens" },
            { text: "Separação legal de bens" },
            { text: "Outros" },
            { text: "Ignorado" }
          ]
        },
        options: {
          SEXOS,
          ESTADOS_CIVIL_HABILITACAO,
          estados: brazilianStates,
          cidades: []
        },
        limitDate: moment(new Date()).add(1, 'day').format('YYYY-MM-DD'),
        casamento: {
          registro: {
            pessoas: []
          }
        },
        A_VISTA_HABILITACAO,
        EDITAL_OUTRA_SERVENTIA,
        UNIAO_ESTAVEL,
        CASAMENTO_RELIGIOSO_EFEITO_CIVIL,
        CASAMENTO_RELIGIOSO,
        CASAMENTO_CIVIL_OUTRO_CARTORIO,
        complementos: [],
        regimeDeBens: [
          { value: 'COMUNHAO_PARCIAL', text: "Comunhão parcial de bens" },
          { value: 'COMUNHAO_UNIVERSAL', text: "Comunhão universal de bens" },
          { value: 'PARTICIPACAO_FINAL_AQUESTOS', text: "Participação final aquestos" },
          { value: 'SEPARACAO_BENS', text: "Separação de Bens" },
          { value: 'SEPARACAO_LEGAL_BENS', text: "Separação legal de bens" },
          { value: 'OUTROS', text: "Outros" },
          { value: 'IGNORADO', text: "Ignorado" }
        ],
        escreventes: [],
        digitadores: [],
        sequenciaRegistro: null,
        tarefaAlteracaoCarga: null,
        deleteds: { genitores: []}
      }
    },
    computed: {
      ...mapGetters({
        cartorioObj: 'auth/getCartorioObj'
      }),
    },
    mounted () {
      this.casamento = {
        ...this.propCasamento,
        registro: {
          ...this.propCasamento.registro,
          pessoas: this.propCasamento.registro.pessoas.map(pessoa => {
            return {
              ...pessoa,
              genitores: [
                ...pessoa.genitores
              ]
            }
          })
        }
      }
      this.loadUsers()
      this.getSequenciaRegistro()

      if (this.casamento.data_casamento) {
        this.casamento.data_casamento = moment(this.casamento.data_casamento).format('YYYY-MM-DD')
      }

      this.tarefaAlteracaoCarga = this.casamento.registro.tarefas.find((tarefa) => {
        return tarefa.acao === 'ALTERACAO' && tarefa.tipo === 'CARGA'
      })
    },
    methods: {
      novaAnotacao (data) {
        this.casamento.anotacoes = data
        this.tratarDocumentos()
      },
      tratarDocumentos () {
        if ((['C', 'CR', 'D'].indexOf(this.casamento.registro.tipo_registro) !== -1)  && this.casamento.registro.anotacoes) {
          this.casamento.registro.pessoas[0].anotacoes =  this.casamento.anotacoes.filter(anotacao => anotacao.pessoa_id == this.casamento.registro.pessoas[0].pessoa_id )
          this.casamento.registro.pessoas[1].anotacoes =  this.casamento.anotacoes.filter(anotacao => anotacao.pessoa_id == this.casamento.registro.pessoas[1].pessoa_id )
        }
      },
      verifyDataCasamento () {
        if (!this.casamento.data_casamento) {
          this.casamento.data_casamento === null
        }
      },
      verifyCasamentoCartorio () {
        if (this.casamento.tipo_casamento == this.CASAMENTO_RELIGIOSO || this.casamento.tipo_casamento == this.CASAMENTO_RELIGIOSO_EFEITO_CIVIL) {
          this.casamento.casamento_em_cartorio = false
        } else {
          this.casamento.casamento_em_cartorio = true
        }
      },
      async getComplemento () {
        if (!this.casamento.regime_bens) return

        const { data } = await RegimeBensService.getRegimeBens({
          cartorio_id: this.$store.state.auth.cartorio_id,
          descricao: this.casamento.regime_bens
        })

        this.complementos = data.map(regime => regime.complemento)
      },
      changeComplemento (val) {
        this.casamento.regime_bens_complemento = val
      },
      changed () {
        if (this.casamento.registro.registro_id) {
          let { livro: { num_livro }, folha, termo } = this.casamento.registro
          const sequenciaLocal = [num_livro, folha, termo].join('')

          if ((this.sequenciaRegistro != sequenciaLocal) || (this.casamento.registro.data_registro != this.propCasamento.registro.data_registro)) {
            this.casamento.registro.origem = 'legado'
          } else {
            this.casamento.registro.origem = 'novo'
          }
        }
      },
      changeOrigin (origem) {
        if (origem === 'novo') {
          this.casamento.registro = {
            ...this.casamento.registro,
            termo: null,
            livro: {
              num_livro: null
            },
            folha: null,
            lado: null
          }
        }
      },
      getSequenciaRegistro () {
        if (!this.sequenciaRegistro  && this.casamento.registro.registro_id ) {
          // pegando sequencia de dado do registro para identificar mudanca
          let { livro: { num_livro }, folha, termo } = this.casamento.registro
          this.sequenciaRegistro = [num_livro, folha, termo].join('')
        }
      },
      removeGenitor (genitor_id) {
        this.deleteds.genitores.push(genitor_id)
      },
      async atualizarRegistro ($event = null) {
        const valid = await this.$validator.validateAll()

        if (!valid) {
          this.scrollList()

          return
        }

        const data = $event

        try {
          loader({active: true, text: 'Atualizando registro...'})

          if (data) {
            this.casamento.registro.cod_motivo_alt = data.codigo
            this.casamento.registro.data_averb_motivo_alt = data.dataAverb
            this.$root.$emit('bv::hide::modal', `modalMotivoAlteracao`)
          }

          let data_atual = null

          if (this.casamento.tipo_casamento == 'Afixação de edital de outra serventia') {
            data_atual = moment().format('YYYY-MM-DD')
          }

          // caso não tenha data casamento vai ser a atual (data atual só vai ter se for 'Afixação de edital de outra serventia')
          this.casamento.registro.data_ocorrido = this.casamento.data_casamento || data_atual
          this.casamento.registro.hora_ocorrido = this.casamento.hora_casamento || moment().format('H:mm')

          //deleteds
          this.casamento.deleteds = this.deleteds

          const res = await CasamentoService.updateCasamento(this.casamento, this.$route.params.id)

          if (res) {
            displayMessage('question', 'Sucesso!', 'Deseja emitir uma ordem de serviço.').then((res) => {
              if (res.value) {
                this.casamento.deleteds = {}

                this.$emit('goOS', this.casamento)
              } else {
                this.$emit('changeRegistro', this.casamento, 5)
              }
            })
          }
        } catch (error) {
          if (Array.isArray(error.response && error.response.data)) {
            const messages = []

            error.response.data.forEach(resp => {
              switch (resp.message) {
              case 'in validation failed on registro.pessoas.0.estado_civil':
                messages.push('Informe o estado civil do Cônjuge 1')
                break
              case 'in validation failed on registro.pessoas.1.estado_civil':
                messages.push('Informe o estado civil do Cônjuge 2')
                break
              }
            })
            if (messages.length) {
              this.showErrorList(messages)
            } else {
              const message = getErrors(error)
              displayMessage('error', 'Erro!', message.message)
            }

          } else {
            const message = getErrors(error)
            displayMessage('error', 'Erro!', message.message)
          }
        } finally {
          loader({ active: false, text: ''})
        }
      },
      showErrorList (errors) {
        const textSwal = `<ul>${errors.map(res => {
          return `<li>${res}</li>`
        })}</ul>`

        const html = textSwal.replace(/\,/g,'')

        return this.displayError('HTML', html)
      },
      scrollList () {
        setTimeout(() => {
          const listagem = document.querySelectorAll('.is-invalid')

          if (listagem.length) {
            listagem[0].scrollIntoView({ behavior: 'smooth', block: 'center', inline: "nearest" })
          }
        }, 100)
      },
      verifyInputs () {
        this.$validator.validate().then(resp => {
          const {errors: {items}} = this.$validator
          const messages = []
        
          items.forEach(item => {
            switch (item.field) {
            case 'tipo_casamento':
              messages.push('Informe o tipo de Casamento')
              break
            case 'data_casamento':
              messages.push('Informe a data do Casamento')
              break
            case 'propPessoa_nome_0':
              messages.push('Informe o nome do cônjuge 1')
              break
            case 'propPessoa_nome_1':
              messages.push('Informe o nome do cônjuge 2')
              break
            case 'propPessoa_data_nascimento_0':
              messages.push('Data de nascimento do cônjuge 1 inválida')
              break
            case 'propPessoa_data_nascimento_1':
              messages.push('Data de nascimento do cônjuge 2 inválida')
              break
            case 'registro_livro':
              messages.push('Informe o número do livro')
              break
            case 'registro_folha':
              messages.push('Informe o número da folha')
              break
            case 'registro_termo':
              messages.push('Informe o número do registro')
              break
            case 'data_registro':
              item.msg == "Campo obrigatório" ? messages.push('Informe a data do registro') : messages.push('Data do registro inválida')
              break
            case 'digitador':
              messages.push('Informe o nome do digitador')
              break
            case 'escrevente':
              messages.push('Informe o nome do escrevente')
              break
            }   
          })

          if (resp && !items.length) {
            this.atualizarRegistro()
          } else {
            let invalids = document.querySelectorAll('.is-invalid')
            this.invalids(invalids)
            !!messages ? this.showErrorList(messages) : ''
          }
        })
      },
      invalids (list) {
        if (list.length) {
          list[0].scrollIntoView({ behavior: 'smooth', block: 'center', inline: "nearest" })
        }
      },
      displayError (type, message) {
        objSwal.error.title = 'Erro ao atualizar'

        if (type === 'HTML') {
          objSwal.error.text = ''
          objSwal.error.html = message
        } else {
          objSwal.error.text = message
          objSwal.error.html = ''
        }

        loader({ text: '', active: false })

        return Swal.fire(objSwal.error).then(() => {
          objSwal.error.text = ''
          objSwal.error.html = ''
        })
      },
      async loadUsers () {
        const response = await UsuarioService.getUsuarios()
        if (!response || !response.data) return

        this.escreventes = []
        this.digitadores = []

        let usuarios = response.data || []

        this.digitadores = usuarios
        this.escreventes = usuarios.filter(usuario => usuario.escrevente === 1 )

        const user = this.$store.state.auth.usuario

        if (!this.casamento.registro.escrevente && !!user.escrevente) {
          this.casamento.registro.escrevente = user.nome
          this.casamento.registro.cargo_escrevente = user.cargo
        }
        if (!this.casamento.registro.digitador) this.casamento.registro.digitador = user.nome

        // nome oficial
        if (!this.casamento.registro.oficial) {
          this.casamento.registro.oficial = this.cartorioObj.nome_oficial
        }
      },
      changeEscrevente () {
        if (this.casamento.registro.escrevente) {
          const selectEscreventes = document.getElementById('selectEscrevente')
          this.casamento.registro.cargo_escrevente  = this.escreventes[selectEscreventes.selectedIndex - 1].cargo
        }
        this.changed()
      }
    }
  }
</script>

<style lang="scss">
  .SegundaViaCasamento {
    &_header {
      background-color: #074F7F !important;
      color: white !important;
      padding: 10px;
      font-size: 18px;
      font-weight: bold;
      border-radius: 0px;
    }


    &_body {
      &_header {
        background-color: #eaeaea !important;
        color: #000 !important;
        padding: 10px;
        font-size: 16px;
        font-weight: bold;
        border-radius: 0px;
      }
    }
  }
</style>
